import { render } from "./DoughnutChart.vue?vue&type=template&id=b8d63c2e&scoped=true&ts=true"
import script from "./DoughnutChart.ts?vue&type=script&lang=ts"
export * from "./DoughnutChart.ts?vue&type=script&lang=ts"

import "./DoughnutChart.scss?vue&type=style&index=0&id=b8d63c2e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d63c2e"]])

export default __exports__